export default {
  Title: require('./Title').default,
  Note: require('./Note').default,
  MultiSelect: require('./MultiSelect').default,
  Meta: require('./Meta').default,
  FileUploader: require('./FileUploader').default,
  SingleSelect: require('./SingleSelect').default,
  Input: require('./Input').default,
}
